import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";

import VModal from "vue-js-modal";

import Navbar from "@/components/Navbar.vue";
import SkipModal from "@/components/SkipModal.vue";
import Hotjar from "@/components/Hotjar.vue";

Vue.config.productionTip = false;

Vue.use(VModal, { dynamicDefault: { draggable: false, resizable: false } });

Vue.filter("capitalize", (value) => {
  if (!value) return "";
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});

Vue.component("navbar", Navbar);
Vue.component("skip-modal", SkipModal);
Vue.component("hotjar", Hotjar);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
